import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import Highlight from '@tiptap/extension-highlight';
import Underline from '@tiptap/extension-underline';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import Link from '@tiptap/extension-link';
import Table from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import TaskList from '@tiptap/extension-task-list';
import { createLowlight, common } from 'lowlight';
import { Markdown } from 'tiptap-markdown';
import Callout from './Callout.js';
import { EmbedV2 } from './EmbedResource/EmbedExtension.js';
import NodeInfo from './NodeInfo.js';
import { TranscriptExtension } from './TranscriptExtension.js';
import { TranscriptItemExtension } from './TranscriptItemExtension.js';
import Embed from './Embed.js';
import { TaskItemExtension } from './TaskItemExtension.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import IndentHandler from './IndentHandler.js';
import ListKeymap from '@tiptap/extension-list-keymap';
import { BlockquoteExtension } from './BlockquoteExtension.js';
import { DropdownItem } from './DropdownItem/DropdownItem.js';
import { DropdownItemTitle } from './DropdownItem/DropdownItemTitle.js';
import { DropdownItemContent } from './DropdownItem/DropdownItemContent.js';
import { SearchHandler } from './SearchHandler.js';
import { DiffHandler } from './Diffs/DiffHandler.js';

const tiptapExtensions = [
  StarterKit.configure({
    codeBlock: false,
    history: false,
    dropcursor: {
      color: cssVar["color-app-primary-text"],
      width: 2
    },
    blockquote: false
  }),
  BlockquoteExtension,
  Placeholder.configure({
    placeholder: "Type something here…",
    emptyEditorClass: "is_empty"
  }),
  Highlight.configure(),
  Underline.configure(),
  Link.configure(),
  CodeBlockLowlight.configure({
    lowlight: createLowlight(common),
    defaultLanguage: "js"
  }),
  TaskList,
  TaskItemExtension.configure({
    nested: true
  }),
  Table.configure({
    resizable: true
  }),
  TableRow,
  TableHeader,
  TableCell,
  Callout,
  NodeInfo.configure({
    types: [
      "heading",
      "paragraph",
      "blockquote",
      "codeBlock",
      "embed",
      "listItem",
      "table",
      "tableRow",
      "tableCell",
      "callout",
      "link",
      "orderedList",
      "bulletList",
      "taskList",
      "listItem",
      "embedV2",
      "transcript",
      "transcriptItem"
    ]
  }),
  Embed,
  EmbedV2,
  Markdown.configure({
    html: true,
    bulletListMarker: "-",
    transformPastedText: true,
    transformCopiedText: false
  }),
  TranscriptExtension,
  TranscriptItemExtension,
  IndentHandler,
  ListKeymap,
  DropdownItem,
  DropdownItemTitle,
  DropdownItemContent,
  SearchHandler,
  DiffHandler
];

export { tiptapExtensions as default };
//# sourceMappingURL=index.js.map
